import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AlertProvider } from "./context/AlertContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

import "font-awesome/css/font-awesome.min.css";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Alert from "./components/Alert";
import ReporteAula from "./components/ReporteAula";
import ReporteIncidencias from "./components/ReporteIncidencias";

import Login from "./auth/Login";
import Register from "./auth/Register";
import Home from "./dashboard/Home";
import Usuario from "./dashboard/Usuario";
import Error from "./auth/Error";
import NotFound from "./auth/NotFound";

const CLIENT_ID =
  "1008473245282-oo6dpk6c2j7ku2kjvsg4f3vfgrc0709j.apps.googleusercontent.com";

function AppWrapper() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [tipoSession, setTipoSession] = useState();
  const location = useLocation();

  useEffect(() => {
    const userSession = localStorage.getItem("userSession");
    const tipoSessionS = localStorage.getItem("tipoSession");
    const tokenSession = localStorage.getItem("tokenSession");

    if (userSession && tokenSession) {
      setIsLoggedIn(true);
      setTipoSession(tipoSessionS);
    }
  }, []);

  const hideNavbar =
    location.pathname != "/" &&
    location.pathname != "/usuario" &&
    !location.pathname.includes("/reporte") &&
    !location.pathname.includes("/incidencias");

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <AlertProvider>
        <Alert />
        {!hideNavbar && <Navbar setIsLoggedIn={setIsLoggedIn} />}
        <Routes>
          <Route
            path="/login"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn} isLogginIn={true}>
                <Login
                  setIsLoggedIn={setIsLoggedIn}
                  setTipoSession={setTipoSession}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="/register"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn} isLogginIn={true}>
                <Register
                  setIsLoggedIn={setIsLoggedIn}
                  setTipoSession={setTipoSession}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {tipoSession === "0" ? (
                  <Home setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Error setIsLoggedIn={setIsLoggedIn} />
                )}
              </ProtectedRoute>
            }
          />

          <Route
            path="/usuario"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {tipoSession === "0" ? (
                  <Usuario setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Error setIsLoggedIn={setIsLoggedIn} />
                )}
              </ProtectedRoute>
            }
          />

          <Route
            path="/reporte/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {tipoSession === "0" ? (
                  <ReporteAula setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Error setIsLoggedIn={setIsLoggedIn} />
                )}
              </ProtectedRoute>
            }
          />
          <Route
            path="/incidencias/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                {tipoSession === "0" ? (
                  <ReporteIncidencias setIsLoggedIn={setIsLoggedIn} />
                ) : (
                  <Error setIsLoggedIn={setIsLoggedIn} />
                )}
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AlertProvider>
    </GoogleOAuthProvider>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
